import { Checkbox as MuiCheckbox, CheckboxProps } from "@mui/material";

import styles from "./Checkbox.module.scss";

export const Checkbox: React.FC<CheckboxProps> = ({ checked, onChange }) => {
  return <MuiCheckbox className={styles.checkbox} checked={checked} onChange={onChange} />;
};
